// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1C4Kz","header":"MessagesList_header__3IhYf","chat":"MessagesList_chat__2OUtd"};